export default "__VITE_ASSET__Dy2ZEL$I__"